export var GetExceptionDataMapper = function (data) {
    var result = {};
    if (data && data.length > 0) {
        result = data.map(function (item) {
            return {
                clientCode: item.clientCode,
                clientName: item.clientName,
                isin: item.isin,
                scripName: item.scripName,
                expiryDate: item.expiryDate,
                upperCap: item.upperCap,
                segment: item.segment,
                segmentid: item.segmentid,
                isNew: item.isNew,
                remarks: item.remarks,
                id: item.id,
                scripCode: item.scripCode,
                createdBy: item.createdBy,
                hairCut: item.hairCut,
                acceptedUppercap: item.acceptedUppercap,
                entryType: item.entryType,
                isEdit: item.isEdit,
                status: item.status,
                acceptedHaircut: item.acceptedHaircut,
                approverRemarks: item.approverRemarks,
            };
        });
    }
    return result;
};
